module.exports = __webpack_public_path__ + "static/Mindstrong-d3dfd415fd9daa11c3ff38a256da966b.jpg";